function decodeTokenPayload(token) {
  if (!token) return undefined;

  try {
    const encodedPayload = token.split('.')[1];
    if (!encodedPayload) return undefined;

    const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '=',
    );

    return JSON.parse(window.atob(paddedBase64));
  } catch (error) {
    return undefined;
  }
}

export function getAdminTokenExpiresAt(token) {
  const payload = decodeTokenPayload(token);
  if (!payload || typeof payload.exp !== 'number') return undefined;

  return payload.exp * 1000;
}

export function isAdminTokenValid(token, now = Date.now()) {
  const expiresAt = getAdminTokenExpiresAt(token);
  return expiresAt !== undefined && expiresAt > now;
}
